<dw-ui-dialog-box
  [title]="
    ('Doc::RemainingAmount' | abpLocalization) + ' : ' + (remainingAmount$ | async | currency)
  "
  (saveFn)="save()"
  [saveDisabled]="!form.dirty || readonly()"
  [displayFooter]="!readonly()"
>
  @if (!readonly()) {
    <form [formGroup]="form">
      <div class="payments-container gap-2" formArrayName="paymentMethods">
        @for (paymentMethod of paymentMethods.controls; let i = $index; track paymentMethod) {
          @if (paymentMethod) {
            <div [formGroupName]="$index" class="payments-container_item gap-4">
              <div>
                <button
                  class="btn btn-outline p-1"
                  [class.btn-outline-primary]="paymentMethod.get('selected').value"
                  (click)="selectPayment(paymentMethod, paymentInputRef)"
                >
                  @if (paymentMethod.get('logo').value?.file) {
                    <img
                      class="aside-picture"
                      class="me-2"
                      [src]="paymentMethod.get('logo').value | fileUrl | async"
                      [title]="
                        paymentMethod.get('paymentMethodId').value
                          | displayName: paymentMethodEnumerationTypeStore.entities()
                      "
                    />
                  } @else {
                    {{
                      paymentMethod.get('paymentMethodId').value
                        | displayName: paymentMethodEnumerationTypeStore.entities()
                    }}
                  }
                </button>
              </div>
              <div>
                <input
                  #paymentInputRef
                  class="form-control"
                  type="number"
                  formControlName="amount"
                  (change)="paymentAmountChanged(paymentMethod)"
                />
              </div>
            </div>
          }
        }
      </div>
    </form>
  }

  <div class="mt-3">
    <document-payment-history-list
      [payments]="payments$ | async"
      (cancelPayment)="cancelPayment($event)"
    ></document-payment-history-list>
  </div>
</dw-ui-dialog-box>
